const common = {

    //调用脚本获取位置信息
    loadBMap(callback) {
        var script = document.createElement('script')
        script.src = 'https://api.map.baidu.com/api?v=2.0&ak=XYGaAE5iabNQYtwv9nivEdn9BpyfHWHw&callback=' + callback
        document.body.appendChild(script)
    },

}

//导出
export default common


// WEBPACK FOOTER //
// ./src/utils/common.js